<template>
  <div>
    <label for="fbidInput"
           class="text-sm">Fb page ID</label>
    <textarea class="form-control mb-4"
              id="fbidInput"
              rows="3"
              v-model="inputValue"
              @input="emitUpdate"
              placeholder="Enter Fb page ID in new lines"
              ref="fbidInput"></textarea>
  </div>
</template>

<script>

export default {
  name: "FbIdInputV2",

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      inputValue: ''
    };
  },

  async created() {
    if (this.value && this.value.length) this.inputValue = this.value.join('\n');
  },

  methods: {
    emitUpdate() {
      this.$emit("input", this.inputValue.split("\n"));
    }
  },

  watch: {
    value: async function (newVal) {
      if (newVal && newVal.length) this.inputValue = newVal.join('\n');
    }
  }
};
</script>

<style lang="scss" scoped>
.fbid-input-pills {
  .pills-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 4px 8px;
    min-height: 38px;
    background: #fff;
  }

  .pill {
    background: #e3e3e3;
    color: #333;
    border-radius: 12px;
    padding: 2px 10px;
    margin: 2px 4px 2px 0;
    display: flex;
    align-items: center;
    font-size: 0.95em;
  }

  .remove-pill {
    margin-left: 6px;
    cursor: pointer;
    color: #888;
    font-weight: bold;
    font-size: 1.1em;
  }

  .fbid-input {
    border: none;
    outline: none;
    flex: 1;
    min-width: 120px;
    font-size: 1em;
    padding: 4px 0;
    background: transparent;
  }
}
</style>